module.exports = "<svg class=\"Svg Svg--podium\" viewBox=\"0 0 150 150\"><path d=\"M65,0 C60,0 55,5 55,10 L55,20 L45,20 L15,50 L15,70 L45,70 L55,130 L35,140 L35,150 L115,150 L115,140 L95,130 L105,70 L135,70 L135,50 L105,20 L65,20 L65,10 L70,10 C72.8125,10 75,7.34375 75,5 C75,2.65625 72.5,0 70,0 C67.5,0 70,0 65,0 L65,0 Z M65,130 L56.71875,80 L75.15625,80 L75,130 L65,130 L65,130 Z M30,50 L50,30 L55,30 L55,40 L65,40 L65,30 L100,30 L120,50 L30,50 L30,50 Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ../~/svg-inline-loader!../images/podium.svg
// module id = 546
// module chunks = 0